import * as React from 'react';

// HORO-10509: white circle badge + classic Facebook blue "f" — the actual
// icon for the Sign in screen's (blue) Facebook button, per reference
// image. Replaces FacebookGlyphIcon (a flat glyph with no circle, which
// was the wrong one). Same shape as FacebookLoginIconWhite, just the "f"
// in brand blue (#0866FF) instead of that component's purple (#47429C),
// which is used elsewhere (EntryStep's stacked OAuth buttons) and left
// untouched.
const FacebookBadgeIcon = ({ width = 24, height = 24, ...props }) => (
    <svg width={width} height={height} viewBox="0 0 33 32" fill="none" {...props}>
        <circle cx="16.5" cy="16" r="16" fill="white" />
        <path
            fill="#0866FF"
            d="M22.72 20.445 23.433 16h-4.267v-3.11c0-1.245.445-2.223 2.4-2.223h2.045V6.578c-1.156-.178-2.4-.355-3.556-.355-3.644 0-6.222 2.222-6.222 6.222V16h-4v4.445h4v11.289c.889.177 1.778.266 2.667.266.889 0 1.777-.088 2.666-.266v-11.29h3.556Z"
        />
    </svg>
);

export default FacebookBadgeIcon;
